import commonPostTypeConfig from '../../common/postTypes/payment'

export default function initPostType({ wapp }) {
    return wapp.client.postTypes.getPostType({
        name: 'payment',
        addIfThereIsNot: true,
        statusManager: commonPostTypeConfig.getStatusManager()
    })
}
